// src/services/authService.js
// نسخه نهایی - کاربران فقط در /users روی سرور ذخیره می‌شوند
// localStorage فقط برای توکن JWT و userId استفاده می‌شود
import { setToken, setUserId, getToken, getUserId, removeToken, removeUserId } from '../utils/secureStorage';
import axios from "axios";

// ✅ تغییر یافت: همه درخواست‌های داده به دروازه‌بان می‌روند
const API_BASE_URL = `${process.env.REACT_APP_API_URL || ''}/db`; 
console.log('✅ API_BASE_URL (Gateway):', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

// ✅ توکن JWT به صورت خودکار به همه درخواست‌های axios اضافه می‌شود
api.interceptors.request.use((config) => {
  try {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {}
  return config;
});



// ============================================================
//  توابع کمکی برای کار با /users (سرور = منبع اصلی)
// ============================================================

/** دریافت لیست کاربران از سرور */


/** به‌روزرسانی یک کاربر مشخص در سرور */
const updateUser = async (userId, updates) => {
  try {
    const res = await api.patch(`/users/${userId}`, updates);
    return res.data;
  } catch (error) {
    console.error('❌ خطا در به‌روزرسانی کاربر:', error.message);
    throw new Error('خطا در ذخیره‌سازی');
  }
};

// ============================================================
//  توابع اصلی
// ============================================================

// ۱. جستجوی کاربر بر اساس phone (از سرور)
// ۱. جستجوی کاربر بر اساس phone (از مسیر عمومی سرور - بدون نیاز به توکن)
// ۱. جستجوی کاربر بر اساس phone (استفاده از POST برای پایداری ۱۰۰٪ در مرورگر و APK)
export const getUserByPhone = async (phone) => {
  try {
    const normalizedPhone = String(phone || '').trim();
    if (!normalizedPhone) return null;
    console.log(`🔍 جستجوی کاربر با شماره: "${normalizedPhone}"`);

    // ✅ آدرس کامل سرور (بدون /db)
    const API_ROOT = process.env.REACT_APP_API_URL || 'https://yadoo20.ir/api';
    
    // ✅ تغییر مهم: استفاده از POST به جای GET
    const res = await axios.post(`${API_ROOT}/users/check-phone`, { phone: normalizedPhone });
    
    const users = Array.isArray(res.data) ? res.data : [];
    const matches = users.filter(u => String(u.phone || '').trim() === normalizedPhone);

    if (matches.length === 0) {
      console.log(`❌ کاربری با شماره "${normalizedPhone}" یافت نشد`);
      return null;
    }

    const foundUser = matches.find(u => u.password) || matches[0];
    console.log(`✅ کاربر پیدا شد:`, foundUser.id, `(از ${matches.length} تطابق)`);
    return foundUser;
  } catch (error) {
    console.error('❌ خطا در جستجوی کاربر:', error.message);
    throw new Error('خطا در ارتباط با سرور');
  }
};

// ۲. ورود با رمز عبور (سرور-محور)
export const loginWithPassword = async (phone, password) => {
  try {
    const normalizedPhone = String(phone || '').trim();
    if (!normalizedPhone || !password) return null;

    // ✅ درخواست به سرور خودمان (آدرس کامل برای سازگاری با APK)
    const API_ROOT = process.env.REACT_APP_API_URL || 'https://yadoo20.ir/api';
    const response = await axios.post(`${API_ROOT}/auth/login`, {
      phone: normalizedPhone,
      password: password
    });

    const { token, user } = response.data;

    // ✅ ذخیره امن توکن و userId
    setToken(token);
    setUserId(String(user.id));

    console.log('✅ ورود موفق:', user.id);
    return user; // کاربر بدون پسورد برگردانده می‌شود
  } catch (error) {
    console.error('❌ خطای ورود:', error);
    if (!error.response) {
      throw new Error('خطای شبکه یا CORS. لطفا اتصال اینترنت را بررسی کنید.');
    }
    const serverError = error.response?.data?.error || error.response?.data?.message;
    throw new Error(serverError || 'شماره یا رمز عبور اشتباه است');
  }
};

// ۳. به‌روزرسانی رمز عبور (PATCH روی سرور)
// ۳. به‌روزرسانی رمز عبور (درخواست مستقیم به سرور)
export const updateUserPassword = async (phone, newPassword) => {
  try {
    const normalizedPhone = String(phone || '').trim();

    // خواندن OTP از sessionStorage
    let otpCode = '';
    try {
      const stored = sessionStorage.getItem(`otp_${normalizedPhone}`);
      if (stored) {
        const { code, expiry } = JSON.parse(stored);
        if (Date.now() <= expiry) otpCode = String(code);
      }
    } catch {}

    if (!otpCode) {
      throw new Error('کد تأیید معتبر نیست. لطفاً از ابتدا تلاش کنید');
    }

    const API_ROOT = process.env.REACT_APP_API_URL || 'https://yadoo20.ir/api';
    await axios.post(`${API_ROOT}/auth/reset-password`, {
      phone: normalizedPhone,
      newPassword,
      otpCode,
    });

    try { sessionStorage.removeItem(`otp_${normalizedPhone}`); } catch {}
    return true;
  } catch (error) {
    const msg = error.response?.data?.error || error.message || 'خطا در بروزرسانی رمز عبور';
    throw new Error(msg);
  }
};





export const changePassword = async (oldPassword, newPassword) => {
  try {
    const API_ROOT = process.env.REACT_APP_API_URL || 'https://yadoo20.ir/api';
    const token = getToken();
    if (!token) throw new Error('لطفاً ابتدا وارد شوید');

    const response = await axios.post(
      `${API_ROOT}/auth/change-password`,
      { oldPassword, newPassword },
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    const msg = error.response?.data?.error || 'خطا در تغییر رمز عبور';
    throw new Error(msg);
  }
};




// ۴. ثبت‌نام کاربر جدید (POST روی سرور)
export const registerUser = async (userData) => {
  try {
    console.log('📝 داده‌های دریافتی برای ثبت‌نام:', userData);

    // بررسی وجود قبلی
    const existing = await getUserByPhone(userData.phone);
    if (existing) {
      throw new Error('این شماره موبایل قبلاً ثبت شده است');
    }

    // ساخت کاربر با تمام فیلدهای لازم
    const now = new Date().toISOString();
    const newUser = {
      
      name: `${userData.firstName} ${userData.lastName}`.trim(),
      fullName: `${userData.firstName} ${userData.lastName}`.trim(),
      role: userData.role,
      email: `${userData.phone}@example.com`,
      phone: userData.phone,
      wallet: 0,
      pendingAmount: 0,
      enrolledCourses: [],
      active: true,
      createdAt: now,
      grade: userData.grade || '',
      field: userData.field || '',

      firstName: userData.firstName,
      lastName: userData.lastName,
      password: userData.password,
      coins: 0,
      xp: 0,
    };

    // اطلاعات دانش‌آموز برای والدین
    if (userData.role === 'parent' && userData['id-student']) {
      newUser['firstName-student'] = userData['firstName-student'];
      newUser['lastName-student'] = userData['lastName-student'];
      newUser['grade-student'] = userData['grade-student'] || '';
      newUser['field-student'] = userData['field-student'] || '';
      newUser['phone-student'] = userData['phone-student'];
      newUser['id-student'] = userData['id-student'];
      newUser['coins-student'] = userData['coins-student'] || 0;
      newUser['xp-student'] = userData['xp-student'] || 0;
    }

    // ✅ ارسال به سرور خودمان (آدرس کامل برای سازگاری با APK)
    const API_ROOT = process.env.REACT_APP_API_URL || 'https://yadoo20.ir/api';
    const response = await axios.post(`${API_ROOT}/auth/register`, {
      firstName: userData.firstName,
      lastName: userData.lastName,
      phone: userData.phone,
      password: userData.password,
      role: userData.role,
      grade: userData.grade,
      field: userData.field
    });

    const { token, user } = response.data;
    
    // ✅ ذخیره امن توکن و شناسه
    setToken(token);
    setUserId(String(user.id));

    return user;
  } catch (error) {
    console.error('❌ خطا در ثبت‌نام:', error.message);
    throw error;
  }
};

// ============================================================
//  OTP (ارسال و تأیید کد) - بدون کوچکترین تغییری
// ============================================================

const SMS_MODE = process.env.REACT_APP_SMS_MODE || 'sandbox';
let currentPhoneForOtp = null;

export const sendOtp = async (phone) => {
  try {
    const otpCode = Math.floor(100000 + Math.random() * 900000).toString();

    const getSmsBaseUrl = () => {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://yadoo20.ir/api';
      if (/^https?:\/\//i.test(apiUrl)) return apiUrl.replace(/\/api\/?$/, '');
      return 'https://yadoo20.ir';
    };
    const smsUrl = `${getSmsBaseUrl()}/api/send-sms`;
    const templateId = process.env.REACT_APP_SMSIR_TEMPLATE_ID || 'sandbox';

    // 🆕 همیشه به سرور می‌فرستیم (برای ذخیره OTP، حتی در sandbox)
    const response = await axios({
      method: 'post',
      url: smsUrl,
      headers: { 'Content-Type': 'application/json' },
      data: {
        mobile: phone,
        templateId,
        parameters: [{ name: 'CODE', value: otpCode }],
        smsMode: SMS_MODE,
      }
    });

    if (SMS_MODE === 'real') {
      if (!response.data || response.data.status !== 1) {
        throw new Error(`خطا در ارسال پیامک: ${response.data?.message || 'خطای ناشناخته'}`);
      }
      console.log(`✅ پیامک به ${phone} ارسال شد`);
    } else {
      console.log(`📱 [SANDBOX] کد تست برای ${phone}: ${otpCode}`);
    }

    const expiry = Date.now() + 5 * 60 * 1000;
    sessionStorage.setItem(`otp_${phone}`, JSON.stringify({ code: otpCode, expiry }));
    currentPhoneForOtp = phone;
    return otpCode;
  } catch (error) {
    console.error('❌ خطا در ارسال OTP:', error.message);
    throw new Error('خطا در ارسال کد تأیید');
  }
};

export const verifyOtp = (enteredCode, sentCode) => {


  const phone = currentPhoneForOtp;
  if (phone) {
    const stored = sessionStorage.getItem(`otp_${phone}`);
    if (stored) {
      try {
        const { code, expiry } = JSON.parse(stored);
if (Date.now() <= expiry && code === enteredCode) {
  // 🆕 OTP را نگه می‌داریم — برای بازنشانی رمز لازم است
  console.log('✅ کد تایید شد (از sessionStorage)');
  return true;
}
      } catch (e) {
        console.warn('⚠️ خطا در خواندن sessionStorage:', e);
      }
    }
  }

  const result = enteredCode === sentCode;
  if (result) console.log('✅ کد تایید شد (مقایسه با sentCode)');
  else console.log('❌ کد نادرست');
  return result;
};

// ============================================================
//  توابع کمکی
// ============================================================

/**
 * ⚠️ getCurrentUser دیگر از localStorage کاربر را نمی‌خواند.
 * چون کاربر باید از سرور گرفته شود، این تابع فقط userId را برمی‌گرداند.
 * کامپوننت‌ها باید از useAuth استفاده کنند.
 */
export const getCurrentUser = () => {
  try {
    const userId = getUserId();
    return userId ? { id: userId } : null;
  } catch {
    return null;
  }
};

/** خروج: پاک کردن توکن و userId */
export const logout = () => {
  removeToken();
  removeUserId();
};

// ============================================================
//  خروجی نهایی
// ============================================================
export default {
  getUserByPhone,
  loginWithPassword,
  updateUserPassword,
  changePassword,
  registerUser,
  sendOtp,
  verifyOtp,
  getCurrentUser,
  logout,
};